import { render, staticRenderFns } from "./ImageWithHover.vue?vue&type=template&id=4e3357fa&scoped=true&"
import script from "./ImageWithHover.vue?vue&type=script&lang=ts&"
export * from "./ImageWithHover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3357fa",
  null
  
)

export default component.exports